<script setup lang="ts">
import FormToggle from '@form/form-toggle.vue';
import { ref, watch } from 'vue';
import CoreIcon from '@core/core-icon.vue';
import { useThemeStore } from '@/store/theme';
import { storeToRefs } from 'pinia';

const themeStore = useThemeStore();
const { colorScheme } = storeToRefs(themeStore);
</script>
<template>
	<label class="part-app-theme-switcher">
		<div class="part-app-theme-switcher__icons">
			<core-icon v-show="colorScheme === 'light'" name="sun" viewBox="0 0 20 20" />
			<core-icon v-show="colorScheme === 'dark'" name="moon" viewBox="0 0 20 20" />
		</div>
		<form-toggle
			v-model="colorScheme"
			tag="span"
			true-value="dark"
			false-value="light"
			@update:modelValue="themeStore.save"
			class="part-app-theme-switcher__toggle"
		/>
	</label>
</template>
<style lang="scss">
.part-app-theme-switcher {
	cursor: pointer;
	padding: 0.9rem 1.1rem;
	background: rgba(var(--color-active-rgb), 0.12);
	border: 1px solid rgba(var(--color-active-rgb), 0.12);
	border-radius: 10rem;
	display: flex;
	align-items: center;
	gap: 1.6rem;
	transition: background-color ease 0.17s;

	@include min-desktop {
		&:hover {
			background: rgba(var(--color-active-rgb), 0.15);
		}
	}

	&__icons {
		flex: 0 0 auto;
		width: 1.8rem;
		fill: var(--color-active);
		svg {
			width: 100%;
		}
	}
	&__toggle {
		flex: 0 0 auto;
	}
}
</style>
